<template>
  <div class="flex flex-col justify-center">
    <h2 class="flex-1 text-2xl text-center mb-8">请作出你的选择：</h2>
    <div class="flex-1 flex reader-option">
      <div class="flex-1 text-center relative text-2xl">
        <input
          :id="`yes_${index}`"
          v-model="value"
          type="radio"
          value="yes"
          :disabled="content.input"
        />
        <label :for="`yes_${index}`">YES</label>
      </div>
      <div class="flex-1 text-center relative text-2xl">
        <input
          :id="`no_${index}`"
          v-model="value"
          type="radio"
          value="no"
          :disabled="content.input"
        />
        <label :for="`no_${index}`">NO</label>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { IContent } from '@/store/modules/common/types';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class GetReaderOption extends Vue {
  @Prop({ type: Object, default: () => {} }) content!: IContent;
  @Prop({ type: Number }) index!: number;
  value = '';

  @Watch('value')
  handleValue() {
    this.$emit('selected', this.value);
  }
}
</script>

<style lang="scss" scoped>
.reader-option {
  input {
    display: none;
    width: 100%;
    height: 100%;
  }
  label {
    cursor: pointer;
  }
  input:checked + label::before {
    position: absolute;
    top: 40px;
    left: 50%;
    margin-left: -12px;
    content: '👆';
  }
}
</style>
